import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { LAYOUT_CONFIG } from 'fuse-core/services/layout-config.service';

@NgModule()
export class FuseModule
{
    constructor(@Optional() @SkipSelf() parentModule: FuseModule)
    {
        if ( parentModule )
        {
            throw new Error('FuseModule is already loaded. Import it in the AppModule only!');
        }
    }

    static forRoot(config): ModuleWithProviders<FuseModule>
    {
        return {
            ngModule : FuseModule,
            providers: [
                {
                    provide : LAYOUT_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
